const contentTogglers = document.querySelectorAll('.js-content-toggler');

contentTogglers.forEach(contentToggler => {
    const contentTogglerLinks = contentToggler.querySelectorAll('.js-content-toggler-link');
    const contentTogglerContent = contentToggler.querySelectorAll('.js-content-toggler-content');

    contentTogglerLinks.forEach(link => {
        link.addEventListener('click', e => {
            const contentID = link.getAttribute('data-id');

            contentTogglerLinks.forEach(link => {
                link.removeAttribute('data-active');
            });

            e.currentTarget.setAttribute('data-active', '');


            contentTogglerContent.forEach(content => {
                if (content.getAttribute('data-id') === contentID) {
                    content.setAttribute('data-active', 'true');
                } else {
                    content.removeAttribute('data-active');
                }
            });
        });
    });
});
